// Theme Reducer - Centralized theme state management

// Action Types
export const SET_CURRENT_THEME = 'theme/SET_CURRENT_THEME';
export const THEME_CHANGED = 'theme/THEME_CHANGED';

// Action Creators
export const setCurrentTheme = (theme) => ({
  type: SET_CURRENT_THEME,
  payload: theme,
});

export const themeChanged = (theme) => ({
  type: THEME_CHANGED,
  payload: theme,
});

// Initial State
const initialState = {
  currentTheme: 'light', // Default theme
  previousTheme: null,
};

// Reducer
const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_THEME:
      return {
        ...state,
        currentTheme: action.payload,
      };
    
    case THEME_CHANGED:
      return {
        ...state,
        previousTheme: state.currentTheme,
        currentTheme: action.payload,
      };
    
    default:
      return state;
  }
};

// Selectors
export const getCurrentTheme = (state) => state?.theme?.currentTheme || 'light';
export const getPreviousTheme = (state) => state?.theme?.previousTheme || null;

export default themeReducer;